import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=df313a0c&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"
import style0 from "./Detail.vue?vue&type=style&index=0&id=df313a0c&prod&scoped=scoped&lang=css"
import style1 from "./Detail.vue?vue&type=style&index=1&id=df313a0c&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df313a0c",
  null
  
)

export default component.exports